import { node, shape, string } from "prop-types"
import { Heading } from "@planningcenter/doxy-web"

const GroupPropType = shape({
  attributes: shape({
    name: string.isRequired,
    church_center_web_url: string.isRequired,
    header_image: shape({ medium: string.isRequired }).isRequired,
    enrollment_status: string.isRequired,
    schedule: string,
  }).isRequired,
})

export function Group({ group }) {
  return (
    <Card>
      <a href={group.attributes.church_center_web_url} className="d-b">
        <Image
          src={group.attributes.header_image.medium}
          alt={`Logo for ${group.attributes.name}`}
          loading="lazy"
        />
        <Caption>
          <Heading level={1} size={4} text={group.attributes.name} />
          <EnrollmentStatus>
            {group.attributes.enrollment_status}
          </EnrollmentStatus>
        </Caption>
        {group.attributes.schedule && (
          <Schedule>{group.attributes.schedule}</Schedule>
        )}
      </a>
    </Card>
  )
}

Group.propTypes = {
  group: GroupPropType.isRequired,
}

function Card({ children }) {
  return <article className="d-b">{children}</article>
}
Card.propTypes = { children: node }

function Image({ alt, src, ...props }) {
  return (
    <div className="card-list-item__image">
      <img loading="lazy" alt={alt} src={src} {...props} />
    </div>
  )
}
Image.propTypes = {
  alt: string.isRequired,
  src: string.isRequired,
}

function EnrollmentStatus({ children }) {
  return (
    <span
      className={`badge ml-2 ${children}-badge`}
      style={{ textTransform: "capitalize" }}
    >
      {children}
    </span>
  )
}
EnrollmentStatus.propTypes = { children: node }

function Caption({ children }) {
  return <div className="d-f jc-sb ai-fs">{children}</div>
}
Caption.propTypes = { children: node }

function Schedule({ children }) {
  return <div className="c-tint1 fs-13">{children}</div>
}
Schedule.propTypes = { children: node }
